<template>
<div class="chapter">
<div class="inner_page">
<p class="centera"><a id="ch00_fm04"></a><a id="page_v"><em>This book is dedicated to my dear friends Ted and Vada Stanley,<br/>for being there for me, and whose friendship, love, and support<br/>throughout the years continues to be cherished.</em></a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?d02ddb06